import { render, staticRenderFns } from "./applyReg.vue?vue&type=template&id=fc3494fe&scoped=true"
import script from "./applyReg.vue?vue&type=script&lang=js"
export * from "./applyReg.vue?vue&type=script&lang=js"
import style0 from "./applyReg.vue?vue&type=style&index=0&id=fc3494fe&prod&lang=css"
import style1 from "./applyReg.vue?vue&type=style&index=1&id=fc3494fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3494fe",
  null
  
)

export default component.exports